<template>
  <CContainer fluid class="p-0" v-show="!storePageLoading">
        <CRow>
            <CCol xl="12" md="12">
                <div class="position-relative">
                    <CEmbed
                        tag="div"
                        :src="this.src"
                        frameborder="0"
                    />
                    <CButton
                        color="secondary"
                        :class="['button','button--preview','shadow']"
                        @click="$router.push({ name: 'forms' })"
                    >
                        <span class="button__icon text-white-50">
                            <CIcon :content="$options.icons.cilArrowThickFromRight"/>
                        </span>
                        <span class="button__text">
                            {{ $t("back") }}
                        </span>
                    </CButton>
                    <transition name="fade">
                        <CElementCover 
                            :boundaries="[{ sides: ['top', 'left'], query: 'iframe' }]"
                            :opacity="0.8"
                            v-if="loading"
                        >
                            <h1 class="d-inline">{{ $t(loading_message) }} </h1><CSpinner v-if="spinner_show" id="spinner" size="5xl" color="dark"/>
                        </CElementCover>
                    </transition>
                </div>
            </CCol>
        </CRow>
    </CContainer>
</template>

<script>
import axios from 'axios';
import { cilArrowThickFromRight } from '@coreui/icons';
import pageMixin from '~/mixins/page.js';
export default {
    name:"FormPreviewPage",
    middleware: ["auth","page"],
    mixins: [ pageMixin ],
    layout: "preview",
    icons:{
        cilArrowThickFromRight
    },
    data(){
        return {
            landing_page:"",
            url:"",
            html:null,
            loading:true,
            loading_message:"loading",
            spinner_show:true,
            src:null
        }
    },
    computed:{
        form_id:function(){
            return this.$route.params.uuid
        }
    },
    methods:{
        base64Decode( str ) {
            return decodeURIComponent(escape(window.atob( str )));
        },
        async buildFormPreview(form_uuid){
            try {
                const { data } = await axios.get('/form.api/'+ form_uuid + "/deploy" );
                this.url = this.base64Decode(data.landing_page);
            } catch (error) {
                this.showMessageError(error);
            }
        },
        async getFormPreview(){
            try {
                let axios_config = {
                    baseURL:this.url,
                    method:'GET'
                };
                const { data } = await axios(axios_config);
                this.html = data;
            } catch (error) {
                this.showMessageError(error); 
            }
        },
        getBlobURL(code, type){
            const blob = new Blob([code], { type });
            return URL.createObjectURL(blob);
        }

            
    },
    async mounted(){
        try {
            if(this.form_id){
                
                await this.buildFormPreview(this.form_id);
                await this.getFormPreview();
                if(!this.html){
                    throw { code: 424, message: this.$t("html_does_not_load") };
                }
                this.src = this.getBlobURL(this.html,'text/html');
                this.loading = false;
                this.$store.dispatch('page/updateLoading', {
                    loading: false,
                });
            }
        } catch (error) {
            this.showMessageError(error);
            this.loading_message = "preview_failed";
            this.spinner_show = false;
        }
        
        
    }
}
</script>

<style scoped>
    .embed-responsive{
        width: 100%;
        height: 100vh;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0
    }
</style>